// Errors that have already been shown to the user (e.g. auth/session errors toasted by ApiCall),
// so other error handlers don't show them a second time.
const reportedErrors = new WeakSet();

export const markReported = (error) => {
    if (error instanceof Object) reportedErrors.add(error);
};

export const isReportedError = (error) => error instanceof Object && reportedErrors.has(error);

// A request cancelled on purpose (AbortController, e.g. the component unmounted) is not an error for the user.
export const isCanceledError = (error) => error?.code === 'ERR_CANCELED';
